import React, {useContext} from "react";
import {Box, ButtonRow, Title, Form, Section, Description} from "../styles";
import Button from "components/Button";
import AuthViewModel from "../viewModel";
import Input from "../component/Input";
import {FormProvider} from "react-hook-form";

function ForgotPassword() {
  const {methods, onSendEmail} = useContext(AuthViewModel.Context);

  const {handleSubmit} = methods;

  return (
    <Box>
      <Title>Forgot Password</Title>
      <Description>Enter your e-mail address to receive the verification e-mail</Description>
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSendEmail)}>
          <Section>
            <Input label="Email" fieldName="Email" />
            <ButtonRow>
              <Button type="submit">Send</Button>
            </ButtonRow>
          </Section>
        </Form>
      </FormProvider>
    </Box>
  )
}

export default AuthViewModel.withProvider(ForgotPassword);
